import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section id="home" className="relative min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {/* Left — Content */}
      <div className="relative z-10 flex flex-col justify-start w-full lg:w-1/2 px-8 md:px-16 pt-24 md:pt-28 pb-16 bg-white">
        <div className="max-w-lg">
          {/* Logo brand statement */}
          <div className="mb-8">
            <img
              src="https://static.readdy.ai/image/97714bd9b358da41691b55298de3f442/a3ed0c045a06ae061d06a7b185ca2783.png"
              alt="ReadyBuyer Group"
              className="w-1/2 h-auto object-contain"
            />
          </div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600 mb-6">
            Melbourne&apos;s Property Buyers Network
          </p>
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-950 leading-[1.05] mb-8">
            We Buy.<br />
            You Move<br />
            <span className="text-teal-600">Forward.</span>
          </h1>
          <p className="text-gray-500 text-xl leading-relaxed mb-10 max-w-sm">
            ReadyBuyer Group purchases Melbourne properties directly — no agents, no open homes, no waiting. A written offer in 3 - 5 business days.
          </p>

          {/* Two big CTA buttons */}
          <div className="flex flex-col gap-4">
            <button
              onClick={() => navigate('/sellers')}
              className="group flex items-center justify-between px-8 py-5 bg-gray-950 hover:bg-teal-700 text-white font-semibold rounded-2xl transition-all duration-200 cursor-pointer text-lg w-full"
            >
              <div className="text-left">
                <div className="font-bold text-lg">I am a Seller</div>
                <div className="text-sm text-gray-400 group-hover:text-teal-200 font-normal mt-0.5">Get a written offer in 3 - 5 business days</div>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl group-hover:bg-white/20 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </button>

            <button
              onClick={() => navigate('/agents')}
              className="group flex items-center justify-between px-8 py-5 border-2 border-gray-200 hover:border-teal-600 text-gray-800 hover:text-teal-700 font-semibold rounded-2xl transition-all duration-200 cursor-pointer text-lg w-full"
            >
              <div className="text-left">
                <div className="font-bold text-lg">I am a Real Estate Agent</div>
                <div className="text-sm text-gray-400 group-hover:text-teal-600 font-normal mt-0.5">Submit stock & close deals faster</div>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-xl group-hover:bg-teal-50 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-line text-xl text-gray-500 group-hover:text-teal-600"></i>
              </div>
            </button>
          </div>

          {/* Minimal stats */}
          <div className="mt-12 flex gap-10 border-t border-gray-100 pt-8">
            {[
              { val: '3–5', unit: 'day offer' },
              { val: '$0', unit: 'seller fees' },
              { val: '100%', unit: 'finance ready' },
            ].map((s) => (
              <div key={s.unit}>
                <div className="text-3xl font-extrabold text-gray-950">{s.val}</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide mt-1">{s.unit}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right — Image */}
      <div className="relative w-full lg:w-1/2 h-72 lg:h-auto lg:min-h-screen">
        <img
          src="https://public.readdy.ai/ai/img_res/b98c09073716c122ada69afb64efab10.jpg"
          alt="Melbourne property"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent lg:bg-gradient-to-r lg:from-white/10 lg:to-transparent"></div>

        {/* Floating badge */}
        <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-4">
          <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Offer valid for</div>
          <div className="text-2xl font-extrabold text-gray-950">48 hours</div>
          <div className="text-xs text-teal-600 font-medium mt-0.5">from the time of issue</div>
        </div>
      </div>
    </section>
  );
}
